import './car-single.scss';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

	document.addEventListener( 'DOMContentLoaded', function() {

	// Main image slider (large images)
	const mainSlider = document.querySelector( '.js-imageSliderLarge' );
	
	// Navigation slider (thumbnail images)
	const navSlider = document.querySelector( '.js-imageSliderNav' );

	if ( mainSlider && navSlider ) {
		
		const mainSlideCount = mainSlider.querySelectorAll( '.swiper-slide' ).length;
		
		// Only initialize if there are multiple slides
		if ( mainSlideCount <= 1 ) {
			return;
		}

		// Initialize main slider first
		const mainSwiper = new Swiper( mainSlider, {
			modules: [ Navigation ],
			slidesPerView: 1,
			spaceBetween: 0,
			grabCursor: true,
			allowTouchMove: true,
			// Laad alleen de aangrenzende slide voor; verre slides laden pas bij het naderen.
			lazyPreloadPrevNext: 1,
			navigation: {
				nextEl: navSlider.parentElement.querySelector( '.swiper-button-next' ),
				prevEl: navSlider.parentElement.querySelector( '.swiper-button-prev' ),
			},
		} );

		// Initialize navigation slider
		const navSwiper = new Swiper( navSlider, {
			modules: [ Navigation ],
			slidesPerView: 5,
			spaceBetween: 18,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				667: {
					slidesPerView: 5,
					spaceBetween: 18
				},
				0: {
					slidesPerView: 4,
					spaceBetween: 12
				}
			}
		} );

		// Add click event listeners to navigation slides
		const navSlides = navSlider.querySelectorAll( '.swiper-slide' );
		navSlides.forEach( function( slide, index ) {
			slide.addEventListener( 'click', function() {
				mainSwiper.slideTo( index );
			} );
		} );

		// Sync navigation slider when main slider changes
		mainSwiper.on( 'slideChange', function() {
			const activeIndex = mainSwiper.activeIndex;
			navSwiper.slideTo( activeIndex );
		} );

	}

	// Tab functionality for car data
	const carTabsContainer = document.querySelector( '.js-carSingleTabs' );
	
	if ( carTabsContainer ) {
		
		const tabs = carTabsContainer.querySelectorAll( '.a-toggleButton__item' );
		const panels = carTabsContainer.querySelectorAll( '.o-carSingle__tabPanel' );
		
		// Add ARIA attributes to toggle buttons
		tabs.forEach( function( tab, index ) {
			tab.setAttribute( 'role', 'tab' );
			tab.setAttribute( 'id', 'tab-' + index );
			tab.setAttribute( 'aria-controls', 'tab-panel-' + index );
			tab.setAttribute( 'tabindex', index === 0 ? '0' : '-1' );
			
			if ( index === 0 ) {
				tab.setAttribute( 'aria-selected', 'true' );
			} else {
				tab.setAttribute( 'aria-selected', 'false' );
			}
		} );
		
		// Function to switch tabs
		function switchTab( activeIndex ) {
			
			// Update tabs
			tabs.forEach( function( tab, index ) {
				if ( index === activeIndex ) {
					tab.classList.add( '-active' );
					tab.setAttribute( 'aria-selected', 'true' );
					tab.setAttribute( 'tabindex', '0' );
				} else {
					tab.classList.remove( '-active' );
					tab.setAttribute( 'aria-selected', 'false' );
					tab.setAttribute( 'tabindex', '-1' );
				}
			} );
			
			// Update panels
			panels.forEach( function( panel, index ) {
				if ( index === activeIndex ) {
					panel.classList.add( '-active' );
					panel.removeAttribute( 'hidden' );
					panel.setAttribute( 'tabindex', '0' );
				} else {
					panel.classList.remove( '-active' );
					panel.setAttribute( 'hidden', '' );
					panel.setAttribute( 'tabindex', '-1' );
				}
			} );
			
		}
		
		// Tab click handler
		tabs.forEach( function( tab, index ) {
			
			tab.addEventListener( 'click', function( e ) {
				e.preventDefault();
				switchTab( index );
			} );
			
			// Keyboard navigation
			tab.addEventListener( 'keydown', function( e ) {
				let targetIndex;
				
				if ( e.key === 'ArrowLeft' || e.key === 'ArrowUp' ) {
					e.preventDefault();
					targetIndex = index > 0 ? index - 1 : tabs.length - 1;
					tabs[targetIndex].focus();
					switchTab( targetIndex );
				}
				
				if ( e.key === 'ArrowRight' || e.key === 'ArrowDown' ) {
					e.preventDefault();
					targetIndex = index < tabs.length - 1 ? index + 1 : 0;
					tabs[targetIndex].focus();
					switchTab( targetIndex );
				}
				
				if ( e.key === 'Home' ) {
					e.preventDefault();
					tabs[0].focus();
					switchTab( 0 );
				}
				
				if ( e.key === 'End' ) {
					e.preventDefault();
					tabs[tabs.length - 1].focus();
					switchTab( tabs.length - 1 );
				}
			} );
		} );

		// Mobile "show more" toggle for data table
		var showMoreButton = carTabsContainer.querySelector( '.js-mobileShowMore' );
		if ( showMoreButton ) {
		}

		// Desktop "show more" functionality for data tables
		panels.forEach( function( panel ) {
			const dataTable = panel.querySelector( '.o-carSingle__dataTable' );
			const showMoreBtn = panel.querySelector( '.js-desktopShowMore' );
			
			if ( dataTable && showMoreBtn ) {
				const rows = dataTable.querySelectorAll( '.o-carSingle__dataRow' );
				const rowCount = rows.length;
				
				// Only apply if there are more than 6 rows
				if ( rowCount > 6 ) {
					// Add limited class initially to hide rows beyond 6
					dataTable.classList.add( '-limited' );
					
					// Add click event listener to show more button
					showMoreBtn.addEventListener( 'click', function() {
						dataTable.classList.remove( '-limited' );
						dataTable.classList.add( '-expanded' );
						showMoreBtn.style.display = 'none';
					} );
				}
			}
		} );

	}

} );